import { render, staticRenderFns } from "./DocumentTemplateDetail.vue?vue&type=template&id=20cc2ee2&scoped=true"
import script from "./DocumentTemplateDetail.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateDetail.vue?vue&type=script&lang=js"
import style0 from "./DocumentTemplateDetail.vue?vue&type=style&index=0&id=20cc2ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc2ee2",
  null
  
)

export default component.exports